import React, { ReactElement } from "react";
import SubCategoryList from "../../components/GlobalCategory/Categories";
import Layout from "../../components/layout";

const SubCategoryPage = (): ReactElement => {
  return (
    <Layout>
      <SubCategoryList />
    </Layout>
  );
};

export default SubCategoryPage;
